import controller from './response.controller';
import template from './response.view.html';

let ResponseComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ResponseComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/response/response.component.js
 **/